module.exports = __webpack_public_path__ + "img/logo.7bac85df.svg";